<div
  class="p-8"
  [ngClass]="{
    'bg-white text-ss-brown': donationRequestFormData?.background,
  }"
  [ssDirectus]="{
    collection: 'donationRequestForm',
    item: donationRequestFormData.id,
    fields: ['header', 'background'],
  }"
>
  <div
    class="text-center pb-8 w-3/4 mx-auto"
    [innerHTML]="donationRequestFormData?.header"
  ></div>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" id="donation-form">
    @if (errors()?.length) {
      <ss-www-form-error-listing
        class="block mb-4"
        [formErrors]="errors()!"
      ></ss-www-form-error-listing>
    }
    <ss-www-stepper>
      <ss-www-step>
        <ss-www-step-header>EVENT INFORMATION</ss-www-step-header>
        <ng-container formGroupName="customer">
          <ng-container formGroupName="organizationContact">
            <ss-form-field label="Business/Organization">
              <input ssInput formControlName="name" ssBaseInput />
              <ss-form-field-error forError="pattern">
                Only letters, numbers, and spaces are allowed
              </ss-form-field-error>
              <ss-form-field-error forError="maxlength">
                Name is too long
              </ss-form-field-error>
            </ss-form-field>
          </ng-container>
        </ng-container>

        <ng-container formGroupName="details">
          <ss-form-field label="Event Name">
            <input ssInput formControlName="eventName" ssBaseInput />
            <ss-form-field-error forError="pattern">
              Only letters, numbers, and spaces are allowed
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              Name is too long
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field class="w-1/2" label="Event Date">
            <input
              ssInput
              type="date"
              [min]="minDate()"
              [max]="maxDate()"
              [formControl]="eventDateControl"
              ssBaseInput
            />
            <ss-form-field-error forError="lessThanSixMonths">
              Event must be less than 6 months from today
            </ss-form-field-error>
            <ss-form-field-error forError="moreThanFiveWeeks">
              Event must be more than 5 weeks from today
            </ss-form-field-error>
          </ss-form-field>
        </ng-container>
      </ss-www-step>
      <ss-www-step formGroupName="customer">
        <ss-www-step-header>ORGANIZATION INFORMATION</ss-www-step-header>
        <ng-container formGroupName="organizationContact">
          <ss-form-field label="Organization Email Address">
            <input
              ssInput
              ssForbiddenEmails
              formControlName="emailAddress"
              ssBaseInput
            />
            <ss-form-field-error forError="email">
              Organization email address is invalid.
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              Organization email address is too long.
            </ss-form-field-error>
            <ss-form-field-error forError="forbiddenDomain">
              Your organization email provider is not supported.
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Confirm Organization Email Address">
            <input ssInput formControlName="emailAddressConfirm" ssBaseInput />
            <ss-form-field-error forError="notMatching">
              Organization email addresses do not match.
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Organization Phone Number">
            <input
              ssInput
              formControlName="phoneNumber"
              ssDigitOnly
              type="tel"
              mask="(000) 000-0000"
              ssBaseInput
            />
            <ss-form-field-error forError="minlength">
              Organization phone number must be at least 10 digits.
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              Organization phone number cannot be more than 20 digits.
            </ss-form-field-error>
          </ss-form-field>
        </ng-container>
        <ss-www-address-form
          parentFormGroupName="customer.address"
        ></ss-www-address-form>
      </ss-www-step>
      <ss-www-step formGroupName="customer">
        <ss-www-step-header>CONTACT INFORMATION</ss-www-step-header>
        <ng-container formGroupName="primaryContact">
          <ss-form-field label="First Name">
            <input ssInput formControlName="firstName" ssBaseInput />
            <ss-form-field-error forError="pattern">
              Only letters, numbers, and spaces are allowed
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              First name is too long
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Last Name">
            <input ssInput formControlName="lastName" ssBaseInput />
            <ss-form-field-error forError="pattern">
              Only letters, numbers, and spaces are allowed
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              First name is too long
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Email Address">
            <input
              ssInput
              ssForbiddenEmails
              formControlName="emailAddress"
              ssBaseInput
            />
            <ss-form-field-error forError="email">
              Contact email address is invalid.
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              Contact email address is too long.
            </ss-form-field-error>
            <ss-form-field-error forError="forbiddenDomain">
              Your contact email provider is not supported
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Confirm Email Address">
            <input ssInput formControlName="emailAddressConfirm" ssBaseInput />
            <ss-form-field-error forError="notMatching">
              Contact email addresses do not match.
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Phone Number">
            <input
              ssInput
              formControlName="phoneNumber"
              ssDigitOnly
              type="tel"
              mask="(000) 000-0000"
              ssBaseInput
            />
            <ss-form-field-error forError="minlength">
              Must be at least 10 digits.
            </ss-form-field-error>
            <ss-form-field-error forError="maxlength">
              Must be less than 20 digits.
            </ss-form-field-error>
          </ss-form-field>
        </ng-container>
      </ss-www-step>
      <ss-www-step>
        <ss-www-step-header>REQUEST DETAILS</ss-www-step-header>

        <ng-container formGroupName="details">
          @if (isLocationRequired()) {
            <ss-form-field label="Select a Theater Location">
              <ss-ui-select [data]="theaterLocations">
                <ss-ui-select-trigger
                  ssInput
                  formControlName="location"
                  class="mt-1"
                >
                  Select your requested location
                </ss-ui-select-trigger>
              </ss-ui-select>
            </ss-form-field>
          } @else {
            <ss-form-field label="Select a Show">
              @if (!(shows$ | async)?.length) {
                <ss-form-field-hint
                  >Select an event date first</ss-form-field-hint
                >
              }
              <ss-ui-select [data]="(shows$ | async) ?? []">
                <ss-ui-select-trigger
                  ssInput
                  formControlName="eventCode"
                  class="mt-1"
                >
                  Select your requested show
                </ss-ui-select-trigger>
              </ss-ui-select>
            </ss-form-field>
          }
        </ng-container>

        <ss-form-field
          class="mb-5"
          label="Please attach a PDF letter outlining your request printed on your company letterhead"
          alternativeLabel="PDF Letter attachment"
        >
          <input
            #fileInput
            ssInput
            class="file-button"
            type="file"
            formControlName="letter"
            accept=".pdf"
            value="CHOOSE FILE"
            (change)="onFileInput()"
          />
        </ss-form-field>
        <ng-container formGroupName="details">
          <ss-form-field
            label="What will the complementary letter be used for?"
            alternativeLabel="Purpose description"
          >
            <textarea
              ssInput
              formControlName="usedFor"
              label="Enter purpose..."
              ssBaseInput
            ></textarea>
            <ss-form-field-error forError="maxlength">
              Purpose description is too long
            </ss-form-field-error>
          </ss-form-field>
          <ss-form-field label="Additional Comments">
            <textarea
              ssInput
              formControlName="comments"
              label="Enter additional comments..."
              ssBaseInput
            ></textarea>
            <ss-form-field-error forError="maxlength">
              Additional comments are too long
            </ss-form-field-error>
          </ss-form-field>
          <div class="mt-5 w-72 mx-auto mb-10">
            <ss-button
              class="w-full"
              type="submit"
              buttonColor="principal"
              buttonStyle="filled"
              >SEND</ss-button
            >
          </div>
        </ng-container>
      </ss-www-step>
    </ss-www-stepper>
  </form>
</div>

@if (isSubmitting()) {
  <ss-www-loading-modal>
    <h3 class="text-ss-brown">Submitting your request</h3>
    <p class="text-ss-brown">Please wait...</p>
  </ss-www-loading-modal>
}
